import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk.channels-jsd.title',
		defaultMessage: 'Channels',
		description: 'Title for the inline dialog describing the incoming request channels for JSM',
	},
});
